import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import ClientApplicationJobCard from '../components/ClientApplicationJobCard';
import useClientApplications from '../../../features/jobs/hooks/useClientApplications';
import { clientSideLinks } from '../clientRoutes';
import CardIcon from '../../../shared/components/icons/CardIcon';

function ClientApplicationsPage() {
  const { jobs, loading, error } = useClientApplications();
  return (
    <DashboardShell role="CLIENT" sideLinks={clientSideLinks}>
      <div className="space-y-6">
        <div className="rounded-3xl bg-white p-6 shadow-sm">
          <h1 className="flex items-center gap-3 text-2xl font-bold text-navy"><CardIcon name="application" className="h-6 w-6" />My Applications</h1>
          <p className="mt-2 text-sm text-slate-600">{loading ? 'Loading applications...' : `${jobs.length} ${jobs.length === 1 ? 'job' : 'jobs'} with applications`}</p>
        </div>

        {error && <div className="rounded-3xl bg-rose-50 p-8 text-center text-rose-700 shadow-sm">Error: {error}</div>}
        {!error && loading && <div className="rounded-3xl bg-white p-8 text-center text-slate-600 shadow-sm">Loading applications...</div>}
        {!error && !loading && jobs.length === 0 && <div className="rounded-3xl bg-white p-8 text-center text-slate-500 shadow-sm">No application jobs found.</div>}
        {!error && !loading && jobs.length > 0 && (
          <div className="grid gap-4">
            {jobs.map((job) => <ClientApplicationJobCard key={job.id} job={job} />)}
          </div>
        )}
      </div>
    </DashboardShell>
  );
}

export default ClientApplicationsPage;
